import { TextField } from '@mui/material'
import { Button } from '@mui/material'
import { CardContent } from '@mui/material'
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import AppBar from '@mui/material/AppBar';
import Slider from '@mui/material/Slider';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import { TreeView } from '@mui/x-tree-view/TreeView';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import FormHelperText from '@mui/material/FormControl';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Draggable from 'react-draggable';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import { RotatingLines } from 'react-loader-spinner';
import LoadingButtonBase from '@mui/lab/LoadingButton';
import * as React from 'react';
import * as global from './data/global';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LineChart } from '@mui/x-charts/LineChart';
import Checkbox from '@mui/material/Checkbox';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Modal from '@mui/material/Modal';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Textarea from '@mui/joy/Textarea';
import OutlinedInput from '@mui/material/OutlinedInput';
import Chip from '@mui/material/Chip';
import { Gauge } from '@mui/x-charts/Gauge';
import { Table, TableContainer, TableHead, TableBody, TableRow, TableCell, TableSortLabel, Tabs, Tab } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import Collapse from '@mui/material/Collapse';

// LoadingButton from @mui/lab renders MUI's CircularProgress as its loading indicator by
// default; we want every spinner in the app to be the same shared RotatingLines. Wrapping
// it here supplies a themed RotatingLines when the caller doesn't pass its own
// loadingIndicator, so ~10 call sites don't each have to override it.
//
// Kept as a shim (not moved to components/windowChrome) so its import chain doesn't create
// a cycle: components import from @index.js, so @index.js can't import from components.
const LoadingButton = React.forwardRef(function LoadingButton(props, ref) {
    const { loadingIndicator, ...rest } = props;
    const themedStrokeColor = (typeof window !== 'undefined' && global?.gw?.theme === 'light')
        ? '#333333'
        : '#f4cc8e';
    const defaultIndicator = (
        <RotatingLines
            strokeColor={themedStrokeColor}
            strokeWidth="3"
            animationDuration="0.72"
            width="22"
            visible
        />
    );
    return (
        <LoadingButtonBase
            ref={ref}
            loadingIndicator={loadingIndicator ?? defaultIndicator}
            {...rest}
        />
    );
});

export const MuiMaterials = {
    Box,
    Stack,
    AppBar,
    Slider,
    CssBaseline,
    Toolbar,
    Typography,
    Divider,
    Menu,
    MenuItem,
    styled,
    Paper,
    Grid,
    Card,
    TextField,
    Button,
    CardContent,
    FormControl,
    FormHelperText,
    InputLabel,
    Select,
    ExpandMoreIcon,
    ChevronRightIcon,
    SwapHorizIcon,
    TreeView,
    SimpleTreeView,
    TreeItem,
    createTheme,
    ThemeProvider,
    Draggable,
    BottomNavigation,
    BottomNavigationAction,
    RotatingLines,
    LoadingButton,
    AdapterDateFns,
    DatePicker,
    LocalizationProvider,
    LineChart,
    Checkbox,
    FormGroup,
    FormControlLabel,
    Modal,
    TimePicker,
    AdapterDayjs,
    Radio,
    RadioGroup,
    Tooltip,
    Textarea,
    OutlinedInput,
    Chip,
    Gauge,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableSortLabel,
    Tabs,
    Tab,
    IconButton,
    Checkbox,
    CircularProgress,
    Collapse,
};